import React from 'react';
import Card from 'react-bootstrap/Card';
import 'bootstrap/dist/css/bootstrap.min.css';


const Info = ()  => {

return(
    <>
<Card bg="light">
  <Card.Body id="center-text" >Cleaning | Housekeeping | Services | Extras 
  
  </Card.Body>


</Card>

</>
);
}


export default Info;